module.exports = __webpack_public_path__ + "static/liva-pastacilik-case-study-two-a48c6fb768d9ac5f691ca62a1e4c49db.png";